// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".currentChecker td[data-v-acd7583a],.currentPicker td[data-v-acd7583a]{--tw-bg-opacity:1;background-color:rgba(219,234,254,var(--tw-bg-opacity));font-weight:700}", "",{"version":3,"sources":["<no source>"],"names":[],"mappings":"AAAA,uEAAA,iBAAA,CAAA,uDAAA,CAAA,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
